import React from 'react'
import {
  PreviewCallout,
  PREVIEW_PAGE_ENUM,
} from '@public/components/PreviewCallout'
import { Error } from 'components/Error'
import { LOADER_SIZE } from 'components/Loader'
import { PureSSRIndicator } from 'components/PureSSRIndicator'
import { Seo } from 'components/Seo'
import { WidgetsWrapper } from 'components/Widgets'
import { PAGE_MIN_HEIGHT, WrappedLoader } from 'components/WrappedLoader'
import { ROUTE } from 'constants/routes'
import { SPACE, WIDGET_MAX_WIDTH } from 'Theme'

import { type CmsPage, type CmsWidget } from 'types/graphql-generated'
import { getSeoPropsForCmsPage } from '../getSeoPropsForCmsPage'

interface ConsultationsPageViewProps {
  slug: string
  data: CmsPage
  isLoading: boolean
  widgets: CmsWidget[]
  isPreview?: boolean
  isSearchFilterParamsMode?: boolean
  fallbackMetaTitle?: string
  fallbackDescription?: string
}

export const ConsultationsPageView: React.FC<
  React.PWC<ConsultationsPageViewProps>
> = ({
  slug,
  data,
  isLoading,
  widgets,
  isPreview,
  isSearchFilterParamsMode,
  fallbackMetaTitle,
  fallbackDescription,
}) => {
  if (isLoading && !data) {
    return (
      <WrappedLoader
        loaderSize={LOADER_SIZE.XXXL}
        minHeight={PAGE_MIN_HEIGHT}
      />
    )
  }

  if (!data) {
    return <Error />
  }

  return (
    <>
      <Seo
        {...getSeoPropsForCmsPage(data, {
          fallbackMetaTitle,
          fallbackDescription,
        })}
      />
      {isPreview && (
        <PreviewCallout
          previewOption={PREVIEW_PAGE_ENUM.SHOWROOM_PAGE_PREVIEW}
          backButtonHref={ROUTE.ADMIN_SHOWROOM_PAGE({ id: slug })}
        />
      )}
      <WidgetsWrapper
        widgets={widgets}
        slug={slug}
        mb={{ TABLET: SPACE.PX_40, MOBILE: SPACE.PX_5 }}
        maxWidgetWidth={WIDGET_MAX_WIDTH.ARTICLE}
        isSearchFilterParamsMode={isSearchFilterParamsMode}
      />
      <PureSSRIndicator />
    </>
  )
}
